<template>
  <div class="preview-component">
    <div class="payment-overlay" v-show="paymentShow">
      <div class="payment-base">
        <div class="payment-title-1">
          {{ $t("PRE_EXPLANATION") }}<br />{{ $t("AFTER_EXPLANATION") }}
        </div>
        <div class="payment-title-2">
          {{ $t("PLAN") }}
        </div>
        <table class="table table-borderless">
          <thead>
            <tr>
              <th></th>
              <th>free</th>
              <th>\19,800</th>
              <th>\35,800</th>
              <th>\49,800</th>
            </tr>
          </thead>
          <tbody class="payment-table">
            <tr>
              <td>{{ $t("DL") }}<br />{{ $t("LIMIT") }}</td>
              <td class="table-warning">100{{ $t("SHEETS") }}</td>
              <td class="table-warning">1,000{{ $t("SHEETS") }}</td>
              <td class="table-warning">5,000{{ $t("SHEETS") }}</td>
              <td class="table-warning">10,000{{ $t("SHEETS") }}</td>
            </tr>
            <tr>
              <td>{{ $t("DL") }}<br />{{ $t("LIMIT_2") }}</td>
              <td class="table-active">{{ $t("LIMIT_3") }}</td>
              <td class="table-active">3{{ $t("TIMES") }}</td>
              <td class="table-active">3{{ $t("TIMES") }}</td>
              <td class="table-active">3{{ $t("TIMES") }}</td>
            </tr>
            <tr>
              <td>{{ $t("MINT_F") }}</td>
              <td class="table-warning">{{ $t("NONE") }}</td>
              <td class="table-warning">
                {{ $t("YES") }}<label class="payment-annotation">*1</label>
              </td>
              <td class="table-warning">
                {{ $t("YES") }}<label class="payment-annotation">*1</label>
              </td>
              <td class="table-warning">
                {{ $t("YES") }}<label class="payment-annotation">*1</label>
              </td>
            </tr>
            <tr>
              <td>
                {{ $t("WATERMARK") }}<br />{{ $t("WATERMARK_1") }}<br />{{
                  $t("WATERMARK_2")
                }}
              </td>
              <td class="table-active">{{ $t("YES") }}</td>
              <td class="table-active">{{ $t("NONE") }}</td>
              <td class="table-active">{{ $t("NONE") }}</td>
              <td class="table-active">{{ $t("NONE") }}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>
                <b-button class="payment-select-button" @click="goStripe(1)">{{
                  $t("SELECT")
                }}</b-button>
              </td>
              <td>
                <b-button class="payment-select-button" @click="goStripe(2)">{{
                  $t("SELECT")
                }}</b-button>
              </td>
              <td>
                <b-button class="payment-select-button" @click="goStripe(3)">{{
                  $t("SELECT")
                }}</b-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="payment-comment-1">
          {{ $t("NOT_MINT") }}
        </div>
        <div class="payment-comment-1">
          {{ $t("SAME_MINT") }}
        </div>
        <b-button @click="closePayment">{{ $t("CANCEL") }}</b-button>
      </div>
    </div>

    <h3 class="title">{{ projectName }}</h3>

    <section class="section-generate-form">
      <b-row class="form-label-texts">
        <b-col>
          <p>{{ $t("GENE_1") }}</p>
          <p>{{ $t("GENE_2") }}</p>
        </b-col>
      </b-row>

      <b-row class="form-contents">
        <b-col>
          <b-form-input
            class="content-input"
            id="number-of-images"
            v-model="numberOfImages"
          ></b-form-input>
          <span class="content-input-label">{{ $t("SHEETS") }}</span>
          <b-form-input
            class="content-input"
            id="generate-name"
            v-model="imageName"
          ></b-form-input>
          <b-button
            class="start-preview"
            @click="startPreview()"
            v-bind:disabled="isRunning"
            >{{ $t("CHECK") }}</b-button
          >
          <b-button
            class="download-preview"
            v-bind:disabled="!isDownloadReady"
            @click="downloadPreview()"
            >{{ $t("DL_1") }}</b-button
          >
          <b-button
            type="button"
            class="payment-button"
            @click="openMintTool()"
            v-bind:disabled="!isMintReady"
            >{{ $t("MINT") }}</b-button
          >
        </b-col>
      </b-row>
    </section>

    <section class="section-preview-area">
      <b-row align-h="start">
        <b-col
          cols="auto"
          class="mr-auto p-1"
          v-for="thumbnail in thumbnails"
          v-bind:key="thumbnail.img_name"
        >
          <img :src="thumbnail.img_base64" alt="" />
        </b-col>
      </b-row>
    </section>

    <div class="alert-area">
      <b-alert :show="isFailed" variant="danger">{{ $t("PRE_FILED") }}</b-alert>
    </div>

    <Loading :active.sync="isRunning" :can-cancel="false" />

    <b-modal id="setup-verification" title="BootstrapVue" size="lg">
      <template #modal-header>
        <div></div>
      </template>

      <template #default="{ close }">
        <div class="px-5" style="min-width: 700px">
          <PreviewSetupVerification
            @next="close()"
            @prev="changeTabs"
            @checkDisabledButton="changeSetupVerification"
          />
        </div>
      </template>

      <template #modal-footer>
        <div></div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Const from "../common/Const";
import Loading from "vue-loading-overlay";
import PreviewSetupVerification from "./PreviewSetupVerification.vue";
import axios from "axios";
import { i18n } from '../lang'

const PREVIEW_STATUS_DOWNLOAD_READY = "ready";
const PREVIEW_STATUS_RUNNING = "running";
const PREVIEW_STATUS_FAILED = "failed";
const PREVIEW_STATUS_INITIALIZED = "init";
const PREVIEW_STATUS_MINT_READY = "ready";

export default {
  name: "Preview",
  components: {
    Loading,
    PreviewSetupVerification,
  },
  props: {
    projectName: {
      type: String,
      default: "No Name",
    },
    projectId: {
      type: String,
      require: true,
    },
    previewLoadingInterval: {
      type: Number,
      default: 3000,
    },
    countFailedPreview: {
      type: Number,
      default: 5,
    },
    currentTab: {
      type: Number,
    },
    user_id: {
      type: String,
      require: true,
    },
    paymentLevel: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      numberOfImages: 0,
      imageName: "",
      beforeNumberOfImages: 0,
      statusPreview: PREVIEW_STATUS_INITIALIZED,
      executionArn: "",
      thumbnails: [],
      countRetry: 0,
      paymentShow: false,
      isSetupModal: false,
      statusMint: PREVIEW_STATUS_INITIALIZED,
    };
  },
  computed: {
    isDownloadReady() {
      return this.statusPreview === PREVIEW_STATUS_DOWNLOAD_READY;
    },
    isRunning() {
      return this.statusPreview === PREVIEW_STATUS_RUNNING;
    },
    isFailed() {
      return this.statusPreview === PREVIEW_STATUS_FAILED;
    },
    isMintReady() {
      return this.statusMint === PREVIEW_STATUS_MINT_READY;
    },
  },
  watch: {
    currentTab: function (a, b) {
      if (a === 2 && !this.isSetupModal)
        this.$bvModal.show("setup-verification");
      else this.$bvModal.hide("setup-verification");
    },
  },
  methods: {
    openMintTool() {
      let self = this;
      self.isLoading = true;
      axios
        .get(`${Const.API_URL_PAYMENT_STATUS}/${this.user_id}`, {
          headers: { Authorization: self.$cognito.getToken() },
        })
        .then(function (res2) {
          self.isLoading = false;
          if (res2.data.payment_status === 0) {
            self.openPayment();
          } else {
            window.location.href = "https://vestone-mintingtool.jp/";
          }
        })
        .catch(function (error) {
          console.log(error);
          self.$bvModal
            .msgBoxOk("課金情報取得に失敗しました。")
            .then((value) => {})
            .catch((err) => {
              console.log(err);
            });
          self.isLoading = false;
        });
    },
    getPaymentLevel(aUserId) {
      let self = this;
      axios
        .get(`${Const.API_URL_PAYMENT_STATUS}/${aUserId}`, {
          headers: { Authorization: self.$cognito.getToken() },
        })
        .then(function (res2) {
          switch (res2.data.payment_status) {
            case 0:
              self.$emit("setPaymentLevel", Const.PAYMENT_LEVEL.FREE);
              break;
            case 10:
              self.$emit("setPaymentLevel", Const.PAYMENT_LEVEL.S);
              break;
            case 20:
              self.$emit("setPaymentLevel", Const.PAYMENT_LEVEL.M);
              break;
            case 30:
              self.$emit("setPaymentLevel", Const.PAYMENT_LEVEL.L);
              break;
            case 99:
              self.$emit("setPaymentLevel", Const.PAYMENT_LEVEL.PRE);
              break;
            default:
              self.$emit("setPaymentLevel", Const.PAYMENT_LEVEL.NONE);
              self.$bvModal
                .msgBoxOk(i18n.t("FAILED_BILL"))
                .then((value) => {})
                .catch((err) => {
                  console.log(err);
                });
              self.isLoading = false;
          }

          return;
        })
        .catch(function (error) {
          console.log(error);
          self.$bvModal
            .msgBoxOk(i18n.t("FAILED_BILL"))
            .then((value) => {})
            .catch((err) => {
              console.log(err);
            });
          self.isLoading = false;
        });
    },
    changeSetupVerification(a) {
      this.isSetupModal = a;
    },
    changeTabs() {
      this.$emit("changeTabs", 0);
    },
    goStripe(index) {
      let amount = "";
      switch (index) {
        case 1:
          amount = "19800";
          break;
        case 2:
          amount = "35800";
          break;
        case 3:
          amount = "49800";
          break;
      }

      let self = this;
      const res = axios
        .post(
          `${Const.API_URL_PAYMENT}`,
          {
            user_id: this.user_id,
            amount: amount,
          },
          { headers: { Authorization: this.$cognito.getToken() } }
        )
        .then(function (res1) {
          window.open(res1.data.url, "_blank", "noopener,noreferrer");
          self.closePayment();
        })
        .catch(function (error) {
          console.log(error);
          self.$bvModal
            .msgBoxOk(i18n.t("FAILED_BILL_1"))
            .then((value) => {})
            .catch((err) => {
              console.log(err);
            });
          self.closePayment();
        });
    },
    closePayment() {
      this.paymentShow = false;
    },
    openPayment() {
      this.paymentShow = true;
      return;
    },
    /**
     * プレビュー処理の開始,画像生成処理リクエスト
     */
    async startPreview() {
      try {
        // プロセス状態取得
        const res = await axios.get(`${Const.API_URL_PROCESS_CTRL}/${this.projectId}`, {
          headers: { Authorization: this.$cognito.getToken() },
        })
  
        // 実行中の場合何もしない
        if (res.data.result == "runnig") {
          this.$bvModal
            .msgBoxOk(i18n.t("NOT_PRE"))
            .then((value) => {})
            .catch((err) => {
              console.log(err);
          });
          return
        }

        // 画像の生成: Request Body
        const requestBody = {
          input: JSON.stringify({
            body: {
              project_id: this.projectId,
              number_of_images: parseInt(this.numberOfImages),
              img_name: this.imageName,
            },
          }),
          stateMachineArn: "arn:aws:states:ap-northeast-1:775137989901:stateMachine:create_generate_images_dev",
        }

        // 画像の生成: Request
        const reqStartLambda = await axios.post(
            `${Const.API_URL_BASE}/generate_images/start_lambda`,
            requestBody,
            {
              headers: { Authorization: this.$cognito.getToken() },
            }
          )
        
        // 実行失敗時, エラー表示
        if (reqStartLambda.status !== 200) {
          this.statusPreview = PREVIEW_STATUS_FAILED
          return
        }

        this.executionArn = reqStartLambda.data.executionArn;
        this.intervalPreviewStatus(); // リクエスト完了後,確認処理を継続して行う

      } catch (error) {
        console.log(error);
        this.$bvModal
          .msgBoxOk(i18n.t("PRE_FILED"))
          .then((value) => {})
          .catch((err) => {
            console.log(err);
          });
      } 
    },
    /**
     * サーバにより画像生成処理中
     * 画像生成新緑状況を逐次確認し､完了後プレビュー処理へ移る
     */
    async intervalPreviewStatus() {
      this.statusPreview = PREVIEW_STATUS_RUNNING;
      try {
        // リトライ回数を超過時,Result表示
        for (this.countRetry = 0; this.countFailedPreview > this.countRetry; this.countRetry++){
          const res = await axios.get(
            `${Const.API_URL_BASE}/generate_images/count_images/${this.projectId}`,
            { headers: { Authorization: this.$cognito.getToken() }}
          )
          
          if (res.status !== 200) throw new Error()
          if (res.data["Number of images"] >= this.numberOfImages) break;                     // 正常完了
          if (this.beforeNumberOfImages != res.data["Number of images"]) this.countRetry = 0; // 前回リクエスト時からカウントに変化がある場合, カウントリセット
          
          this.beforeNumberOfImages = res.data["Number of images"]                            // 今回カウント記録
          await new Promise(resolve => setTimeout(resolve, this.previewLoadingInterval))      // Interval待機時間
        }
      } catch (error) {
        
      }

      // プレビュー開始
      this.resultPreview()

    },
    /**
     * 画像データのプレビュー処理
     */
    async resultPreview() {
      const requestBody = {
        executionArn: this.executionArn,
      };

      try {
        // 画像生成処理結果
        const res = await axios.post(`${Const.API_URL_BASE}/generate_images/get_result`, requestBody, {
          headers: { Authorization: this.$cognito.getToken() },
        })
        
        if (res.status !== 200) throw new Error(res)
        switch (res.data.status){
          case "SUCCEEDED": // 成功
            this.statusPreview = PREVIEW_STATUS_DOWNLOAD_READY;
            this.statusMint = PREVIEW_STATUS_MINT_READY;
            break;
          case "RUNNING":   // 実行中の場合 PreviewStatus確認処理へ戻る
            this.intervalPreviewStatus()
            return
          default:
            throw new Error(res)
        }

        const out = JSON.parse(res.data.output)

        // 画像取得
        const resImage = await axios.get(out.location)
        const images = JSON.parse(resImage.data.body);

        // 画像データ整形, 1000件以上は削除
        const imageList = images.slice(0,1000).map((v) => {
          let b64 = v.thumbnail;
          b64 = b64.slice(2).slice(0, -1);
          b64 = "data:image/png;base64," + b64;
          return {
            img_name: v.img_name,
            img_base64: b64,
          };
        });
        this.thumbnails = imageList;
        this.getPaymentLevel(this.user_id);

      } catch (error) {
        this.statusPreview = PREVIEW_STATUS_FAILED;
        this.dangerAlertCount = 5;
        return
      }
    },
    downloadPreview() {
      let self = this;
      axios
        .get(`${Const.API_URL_BASE}/download/${this.projectId}`, {
          headers: { Authorization: this.$cognito.getToken() },
        })
        .then(function (response) {
          if (response.data.result === "OK") {
            window.open(response["data"]["Location"], "_blank");
          } else {
            if (response.data.result === "NG") {
              self.openPayment();
            } else {
              self.$bvModal
                .msgBoxOk(i18n.t("DL_FAILD"))
                .then((value) => {})
                .catch((err) => {
                  console.log(err);
                });
            }
          }
        })
        .catch(function (error) {
          self.$bvModal
            .msgBoxOk(i18n.t("DL_FAILD"))
            .then((value) => {})
            .catch((err) => {
              console.log(err);
            });
          console.log(error);
        });
    },
  },
  destroyed() {
  },
};
</script>

<style scoped>
.payment-select-button {
  background: #147bfc 0% 0% no-repeat padding-box;
  border-radius: 5px;
  border: none;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.3);
  cursor: pointer;
  font-size: 15px;
  opacity: 1;
  width: 74.6%;
}
.payment-base button.btn.btn-secondary:nth-child(6) {
  margin-top: 30px;
}
.payment-comment-1 {
  text-align: right;
  font: normal normal normal 15px/22px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #ff079f;
  font-size: 12px;
  opacity: 1;
}
.payment-annotation {
  width: 15px;
  height: 21px;
  text-align: right;
  font: normal normal normal 15px/22px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #ff079f;
  opacity: 1;
}
.payment-table {
  text-align: center;
  font: normal normal bold 16px/22px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #3e3e3e;
  margin: 20px auto;
  opacity: 1;
}
.payment-table td:first-child {
  font-size: 14px;
}
.payment-title-2 {
  /* UI Properties */
  text-align: center;
  font: normal normal normal 15px/22px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #3e3e3e;
  opacity: 1;
  padding: 10px 0 20px;
}
.payment-title-1 {
  /* UI Properties */
  text-align: center;
  font: normal normal bold 20px/29px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #2d2d2e;
  opacity: 1;
}
.payment-overlay {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.payment-base {
  top: 210px;
  left: 560px;
  max-width: 800px;
  min-height: 660px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 3px 4px 6px #0000001a;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  opacity: 1;
  padding: 40px;
  width: 50%;
}

/** コンポーネント共通 */
.preview-component {
  margin-left: 44px;
  color: #fff;
}
.preview-component .title {
  margin-top: 48px;
  margin-left: 0px;
  text-align: left;
  font-size: 18px;
  font-family: "Noto Sans JP", sans-serif;
  font-weight: 300;
  width: 100%;
  height: 26px;
}

.preview-component .title:before {
  content: "|";
  position: relative;
  width: 4px;
  height: 26px;
  line-height: 26px;
  font-size: 18px;
  font-weight: bold;
  left: -10px;
  color: #fff;
  background-color: #fff;
}

/** フォームセクション */
.section-generate-form {
  margin-top: 34px;
  text-align: left;
}

.section-generate-form .form-label-texts p {
  display: inline-block;
  margin: 0;
  margin-right: 63px;
}
.section-generate-form .form-contents {
  line-height: 40px;
  margin-top: 10px;
}
.section-generate-form .form-contents .content-input {
  display: inline-block;
  width: 220px;
  height: 40px;
}

.section-generate-form .form-contents .content-input-label {
  margin-right: 30px;
  margin-left: 10px;
}
.section-generate-form .form-contents #generate-name {
  margin-right: 120px;
}

.section-generate-form .form-contents .start-preview {
  background-color: #6b3dfb;
  width: 200px;
  height: 40px;
  margin-right: 20px;
}

.section-generate-form .form-contents .download-preview {
  background-color: #147bfc;
  width: 200px;
  height: 40px;
}

.section-generate-form .form-contents .payment-button {
  width: 220px;
  height: 40px;
  /* UI Properties */
  background-color: #00a38a;
}

/** プレビューエリア */

.section-preview-area {
  max-width: 1050px;
  margin-top: 40px;
}

.section-preview-area .row .col {
  width: 100px;
  height: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/Preview.vue